<template>
  <div class="page-body">
    <title-bar title="修改密码">
      <el-button type="default" @click="$router.back()" icon="fa fa-angle-left" :loading="loading">
        返回
      </el-button>
    </title-bar>
    <modify-password-form></modify-password-form>
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import CodeSelect from "@/components/base/CodeSelect";
import SessionStore from "@/utils/SessionStore";
import ModifyPasswordForm from "@/components/ModifyPasswordForm";

export default {
  components: {ModifyPasswordForm, CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
